/* Hindsight BBQ site behavior. Every feature is opt-in through data attributes, so pages work without it. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Phone menu drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-hs-drawer]');
    var opener = document.querySelector('[data-hs-drawer-open]');
    if (!drawer || !opener) return;
    var closer = drawer.querySelector('[data-hs-drawer-close]');
    function open() {
      drawer.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('hs-locked');
      // Focus the panel itself (no focus box on a link); Tab still moves through the links.
      setTimeout(function () { drawer.focus({ preventScroll: true }); }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('hs-locked');
      opener.focus();
    }
    opener.addEventListener('click', open);
    if (closer) closer.addEventListener('click', close);
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key !== 'Tab') return;
      var items = drawer.querySelectorAll('a, button');
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 1280 && drawer.classList.contains('is-open')) close(); });
  }

  /* ---------- Bold today's row in every hours list (restaurant time) ---------- */
  var DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  function dayIndex(word) {
    word = String(word || '').trim().toLowerCase().slice(0, 3);
    for (var i = 0; i < 7; i++) if (DAYS[i].slice(0, 3) === word) return i;
    return -1;
  }
  function initHours() {
    var rows = document.querySelectorAll('[data-hs-days]');
    if (!rows.length) return;
    var today;
    try {
      today = dayIndex(new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone: 'America/New_York' }).format(new Date()));
    } catch (e) { today = new Date().getDay(); }
    rows.forEach(function (row) {
      var parts = row.getAttribute('data-hs-days').split(/\s*(?:-|–|to|&)\s*/i);
      var a = dayIndex(parts[0]), b = dayIndex(parts[parts.length - 1]);
      if (a < 0) return;
      if (b < 0) b = a;
      var hit = a <= b ? today >= a && today <= b : today >= a || today <= b;
      if (hit) row.classList.add('is-today');
    });
  }

  /* ---------- Food card rail arrows (desktop) ---------- */
  function initRails() {
    document.querySelectorAll('[data-hs-rail]').forEach(function (root) {
      if (root.dataset.hsReady) return;
      root.dataset.hsReady = '1';
      var track = root.querySelector('.hs-food__track');
      var prev = root.querySelector('.hs-prev'), next = root.querySelector('.hs-next');
      if (!track || !prev || !next) return;
      function step() { var card = track.firstElementChild; return card ? card.getBoundingClientRect().width + 20 : 300; }
      function update() {
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Reviews: dots + gentle auto-advance ---------- */
  function initReviews() {
    document.querySelectorAll('[data-hs-reviews]').forEach(function (root) {
      if (root.dataset.hsReady) return;
      root.dataset.hsReady = '1';
      var slides = root.querySelectorAll('.hs-reviews__slide');
      var dots = root.querySelectorAll('.hs-reviews__dots button');
      if (slides.length < 2) return;
      var current = 0, timer = null;
      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.hidden = n !== current; });
        dots.forEach(function (d, n) { d.setAttribute('aria-current', n === current ? 'true' : 'false'); });
      }
      function start() { if (!reduceMotion && root.getAttribute('data-autoplay') === 'true') timer = setInterval(function () { show(current + 1); }, 7000); }
      function stop() { clearInterval(timer); }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { stop(); show(n); }); });
      var prevBtn = root.querySelector('.hs-prev'), nextBtn = root.querySelector('.hs-next');
      if (prevBtn) prevBtn.addEventListener('click', function () { stop(); show(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { stop(); show(current + 1); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('focusin', stop);
      show(0);
      start();
    });
  }

  /* ---------- Hero video: load only where it shows (phones by default), fade in, no controls ---------- */
  function initVideo() {
    document.querySelectorAll('[data-hs-video]').forEach(function (root) {
      if (root.dataset.hsReady) return;
      root.dataset.hsReady = '1';
      var video = root.querySelector('video[data-hs-video-src]');
      if (!video || reduceMotion) return;
      if (video.classList.contains('is-phone-only') && window.matchMedia('(min-width: 750px)').matches) return;
      var desktopSrc = video.getAttribute('data-hs-video-src-desktop');
      // Desktop gets the sharper (bigger) copy when there is one; phones keep the lighter 720p file.
      video.src = desktopSrc && window.matchMedia('(min-width: 750px)').matches ? desktopSrc : video.getAttribute('data-hs-video-src');
      video.addEventListener('playing', function () { video.classList.add('is-playing'); });
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      // Background video only: no pause control. If the browser pauses it (tab hidden, etc.), start it again.
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && video.paused) { var r = video.play(); if (r && r.catch) r.catch(function () {}); }
      });
    });
  }

  /* ---------- Photo slider: swipe, arrows, thumbnails ---------- */
  function initSliders() {
    document.querySelectorAll('[data-hs-slider]').forEach(function (root) {
      if (root.dataset.hsReady) return;
      root.dataset.hsReady = '1';
      var track = root.querySelector('.hs-slider__track');
      if (!track) return;
      var slides = track.children;
      var thumbs = root.querySelectorAll('.hs-slider__thumbs button');
      var current = 0;
      function go(i) {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      function sync() {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i === current) return;
        current = i;
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        var t = thumbs[i];
        if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: 'auto' });
      }
      var prev = root.querySelector('.hs-slider__arrow.hs-prev'), next = root.querySelector('.hs-slider__arrow.hs-next');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
      var timer;
      track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(sync, 60); }, { passive: true });
    });
  }

  /* ---------- Background videos (catering band): load only where they play ---------- */
  function initBgVideos() {
    document.querySelectorAll('video[data-hs-bgvideo]').forEach(function (video) {
      if (video.dataset.hsReady || reduceMotion) return;
      if (video.getAttribute('data-hs-where') === 'desktop' && !window.matchMedia('(min-width: 750px)').matches) return;
      video.dataset.hsReady = '1';
      function start() {
        video.src = video.getAttribute('data-hs-bgvideo');
        video.addEventListener('playing', function () { video.classList.add('is-playing'); });
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      if (!('IntersectionObserver' in window)) { start(); return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '300px 0px' });
      io.observe(video.parentNode);
    });
  }

  /* ---------- Catering pickup / delivery tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-hs-tabs]').forEach(function (root) {
      if (root.dataset.hsReady) return;
      root.dataset.hsReady = '1';
      var tabs = root.querySelectorAll('[data-hs-tab]');
      var panels = root.querySelectorAll('[data-hs-panel]');
      function select(name, focus) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-hs-tab') === name;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-hs-panel') !== name; });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t.getAttribute('data-hs-tab')); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          select(tabs[n].getAttribute('data-hs-tab'), true);
        });
      });
    });
    document.querySelectorAll('[data-hs-scroll]').forEach(function (a) {
      if (a.dataset.hsReady) return;
      a.dataset.hsReady = '1';
      a.addEventListener('click', function (e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Menu page: category chips built from the category sections ---------- */
  function initMenuNav() {
    var nav = document.querySelector('[data-hs-mnav]');
    if (!nav) return;
    var track = nav.querySelector('.hs-mnav__track');
    var cats = document.querySelectorAll('[data-hs-mcat]');
    if (!cats.length) { nav.hidden = true; return; }
    var links = [];
    cats.forEach(function (cat) {
      var a = document.createElement('a');
      a.href = '#' + cat.id;
      a.textContent = cat.getAttribute('data-hs-mcat');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        cat.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + cat.id);
      });
      track.appendChild(a);
      links.push(a);
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var i = Array.prototype.indexOf.call(cats, en.target);
        links.forEach(function (l, n) { l.classList.toggle('is-active', n === i); });
        var active = links[i];
        if (active) track.scrollTo({ left: active.offsetLeft - 20, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    cats.forEach(function (c) { io.observe(c); });
  }

  ready(function () {
    initDrawer();
    initHours();
    initRails();
    initReviews();
    initVideo();
    initTabs();
    initSliders();
    initBgVideos();
    initMenuNav();
  });
  document.addEventListener('shopify:section:load', function () {
    initHours();
    initRails();
    initReviews();
    initVideo();
    initTabs();
    initSliders();
    initBgVideos();
  });
})();
